// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2UJsX","content":"LayoutSettings_content__1Jxvo"};